import { render } from "./RichTextEditor.vue?vue&type=template&id=72c334d4&scoped=true&ts=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts"

import "./RichTextEditor.vue?vue&type=style&index=0&id=72c334d4&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c334d4"]])

export default __exports__